import axios, { API_VERSION } from "../config";

export const createLogSummary = async (entityId, body) =>
  axios.post(`${API_VERSION}/llm/${entityId}/logsummary`, body)

export const sendAgentMessage = async (entityId, body) =>
  axios.post(`${API_VERSION}/llm/${entityId}/aimessage`, body)